/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Hero_TitleInputs */

const en_why_listening_hero_title = /** @type {(inputs: Why_Listening_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listen to anything.`)
};

const es_why_listening_hero_title = /** @type {(inputs: Why_Listening_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escucha lo que quieras.`)
};

/**
* | output |
* | --- |
* | "Listen to anything." |
*
* @param {Why_Listening_Hero_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_hero_title = /** @type {((inputs?: Why_Listening_Hero_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Hero_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_hero_title(inputs)
	return en_why_listening_hero_title(inputs)
});